<template>
  <div class="info_block">
    <h3>Delivery Info</h3>
    <div class="info_block_content">
      <div>
      <img id="table" src="../assets/images/delivery.svg">
      </div>
      <p>Fruit Soup delivers to the following districts in Budapest:</p>
      
<p>I, II, III, IV, V, VI, VII, VIII, IX, X, XI, XII, XIII, XIV, XV, XXII and Budaörs.</p>

<p>The shipping area may vary as defined by the mapping system. 
  In order to see if we are delivering to your address please add the exact address to the address bar. 
  Shipping charges may differ by areas in Budapest. 
  </p>
  <p>
  When ordering you will find the exact shipping charge before you place your order.
  You can place your order between 11am and 10.30 pm every day. On international and national holiday, 
  our opening hours can be changed. 
  Please find information in our websites.
  </p>
  </div>
  </div>
</template>

<script>
export default {
  name: "delivery"
};
</script> 

<style scoped>
h3 {
  margin-bottom: 2rem;
  
}
#table{
  height:150px;
  margin-bottom: 1rem;
  margin-top:1rem
}


</style>